import getConfig from 'next/config';

const { GOOGLE_MAPS_WEB_KEY } = getConfig().publicRuntimeConfig;

export default {
  key: GOOGLE_MAPS_WEB_KEY,
  libraries: ['places', 'geometry'],
};
